import { TimesheetOvertimeRequestFragment } from 'generated/resources/graphql'

import { formatSecondsToHM } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import AttendanceOvertimeUtils from 'modules/attendance/lib/utils/OvertimeRequest'

interface Props {
  workedMinutesNotApproved: number
  overtimeRequest?: TimesheetOvertimeRequestFragment | null
}

const overtimeRequestDisclaimer = ({ workedMinutesNotApproved, overtimeRequest }: Props) => {
  let message = ''
  let button = ''
  if (workedMinutesNotApproved === 0 && !overtimeRequest) return { message, button }

  const requestStatus = overtimeRequest?.status || ''
  const requestMinutes = AttendanceOvertimeUtils.minutes(overtimeRequest?.hoursAmountInCents || 0)

  // There's worked time to be approved and is not already requested and pending
  if (
    workedMinutesNotApproved > 0 &&
    !(workedMinutesNotApproved === requestMinutes && overtimeRequest?.status === 'pending')
  ) {
    const time = { time: formatSecondsToHM(workedMinutesNotApproved * 60) }

    if (overtimeRequest) {
      if (overtimeRequest.isEditable) {
        message = i18n.t(
          'clock_in.worked_tooltip.worked_time_not_approved.with_overtime_request.editable',
          time
        )
        button = i18n.t('clock_in.worked_tooltip.edit_request')
      } else {
        message = i18n.t(
          'clock_in.worked_tooltip.worked_time_not_approved.with_overtime_request.non_editable',
          time
        )
        button = i18n.t('clock_in.worked_tooltip.see_request')
      }
    } else {
      message = i18n.t(
        'clock_in.worked_tooltip.worked_time_not_approved.without_overtime_request',
        time
      )
      button = i18n.t('clock_in.mandatory_overtime_reminder.request_overtime')
    }
  } else {
    switch (requestStatus) {
      case 'pending':
        message = i18n.t('clock_in.worked_tooltip.pending_request')
        break
      case 'approved':
        message = i18n.t('clock_in.worked_tooltip.approved_request')
        break
      case 'rejected':
        message = i18n.t('clock_in.worked_tooltip.rejected_request')
        break
    }
    button = i18n.t('clock_in.worked_tooltip.see_request')
  }

  return { message, button }
}

export default overtimeRequestDisclaimer
